module.exports = __webpack_public_path__ + "media/images/photos/man-driving-4f76d56dbfe22315e0872b119006a41f.jpg";